import type { SVGProps } from "react";

export default function ArrowUpIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Icons/alt-arrow-down-svgrepo-com">
        <path
          id="Vector"
          d="M4.16683 12.5L10.0002 7.5L15.8335 12.5"
          stroke="currentColor"
          strokeWidth="1.25528"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
